/**
 * Picks a small illustration for a menu item that has no photo yet, from words in its name and
 * category. It is only a stand-in: a real photo added under Menu always takes its place.
 * Order matters — the first matching rule wins, so specific dishes come before general ones.
 */
const RULES: [RegExp, string][] = [
  [/water|bottle/, "💧"], [/coffee|nescafe|latte|cappuccino/, "☕"], [/\btea\b|plain tea|milk tea/, "🍵"],
  [/juice|smoothie|shake|lassi|faluda/, "🍹"], [/soda|cola|sprite|fanta|soft drink|ginger beer|cream soda/, "🥤"], [/beer|wine|arrack/, "🍺"],
  [/ice cream|sundae/, "🍨"], [/watalappan|pudding|caramel|jelly/, "🍮"], [/curd|yogh?urt/, "🥛"], [/cake|brownie|gateau/, "🍰"], [/fruit/, "🍉"],
  [/kottu|koththu/, "🥘"], [/noodle|pasta|spaghetti|mee\b|chow/, "🍜"], [/fried rice|nasi|biriyani|biryani/, "🍚"], [/lamprais|rice|curry|bath\b/, "🍛"],
  [/soup/, "🍲"], [/salad/, "🥗"], [/burger/, "🍔"], [/pizza/, "🍕"], [/sandwich|submarine|sub\b/, "🥪"], [/hopper|appa|pancake|roti|paratha|pol roti|dosa|thosai/, "🫓"],
  [/bun|bread|pastry|patty|patties|roll|cutlet|samosa|short eat/, "🥟"], [/prawn|shrimp|crab|cuttle|seafood|fish/, "🐟"], [/egg|omelette/, "🍳"],
  [/chicken|devilled|wing/, "🍗"], [/beef|pork|mutton|steak/, "🥩"], [/chips|fries|wedges/, "🍟"],
  [/drink|beverage/, "🥤"], [/dessert|sweet/, "🍮"]
];

export function dishEmoji(name: string, category = ""): string {
  const byName = RULES.find(([pattern]) => pattern.test(name.toLowerCase()));
  return (byName ?? RULES.find(([pattern]) => pattern.test(category.toLowerCase())))?.[1] ?? "🍽️";
}
